// extracted by mini-css-extract-plugin
module.exports = {"block":"ApproveModal_block__1-HeU","isOpen":"ApproveModal_isOpen__jzlUt","shortly":"ApproveModal_shortly__jm-a7"};